export { TextBanner, type TextBannerProps } from "./TextBanner";
